module.exports = __webpack_public_path__ + "img/about-2.5898ef35.png";